<template>
  <SrpModal :isVisible="true" @close="emit('close')">
    <template #content>
      <!-- Dislike form -->
      <div class="dislike-form">
        <div class="dislike-form__header">
          <h2 class="global-h2 dislike-form__title">What's missing the mark? <span class="dislike-form__optional-mark">(optional)</span></h2>
          <div class="dislike-form__subtitle">Any guidance helps us improve future suggestions</div>
        </div>

        <div class="dislike-form__checkboxes-row">
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Wrong Theme" v-model="formData.reasons" /></template>
            <template #text>Wrong Theme</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Images Unrelated" v-model="formData.reasons" /></template>
            <template #text>Images Unrelated</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Low Quality Photos" v-model="formData.reasons" /></template>
            <template #text>Low Quality Photos</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Poor Caption" v-model="formData.reasons" /></template>
            <template #text>Poor Caption</template>
          </SrpCheckbox>
          <SrpCheckbox class="dislike-form__checkbox">
            <template #input><input type="checkbox" value="Other" v-model="formData.reasons" /></template>
            <template #text>Other</template>
          </SrpCheckbox>
        </div>

        <!--<div class="dislike-form__textarea-title">or just tell us:</div>-->

        <textarea class="global-textarea dislike-form__textarea" v-model="formData.feedback"></textarea>
      </div>
      <!-- / Dislike form -->
    </template>

    <template #footer="{ closeModal }">
      <SrpButton
        @click="
          () => {
            resetFormData();
            emit('cancel');
            closeModal();
          }
        "
        color="gray"
        fill="outlined"
        style="margin-right: 12px"
      >
        Cancel
      </SrpButton>
      <SrpButton
        @click="
          () => {
            emit('remove', combinedFeedbackString);
            resetFormData();
            closeModal();
          }
        "
      >
        Remove
      </SrpButton>
    </template>
  </SrpModal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import ShareStopSummaryRepo from "@repos/ShareStopSummaryRepo";

// Components
import SrpButton from "@components/ui/SrpButton.vue";
import SrpModal from "@components/ui/SrpModal.vue";
import SrpCheckbox from "@components/ui/SrpCheckbox.vue";
import LoadingIcon from "@components/ui/LoadingIcon.vue";

const props = withDefaults(
  defineProps<{
    pageId: string;
    postId: string;
  }>(),
  {
    pageId: "",
    postId: "",
  }
);

const emit = defineEmits<{
  (e: "close"): void;
  (e: "cancel"): void;
  (e: "remove", reasonText: string): void;
}>();

// Form Data ==================================================================
class FormData {
  reasons: Array<string> = [];
  feedback = "";
}

const formData = ref<FormData>(new FormData());

function resetFormData() {
  formData.value = new FormData();
}

// Reasons and feedback string ================================================
const combinedFeedbackString = computed<string>(() => {
  let combinedFeedbackString = "";

  if (formData.value.reasons.length) {
    combinedFeedbackString = formData.value.reasons.join(", ");
  }

  if (formData.value.reasons.length && formData.value.feedback.length) {
    combinedFeedbackString += ", \n";
  }
  combinedFeedbackString += formData.value.feedback;

  return combinedFeedbackString;
});
</script>

<style scoped lang="scss">
// Dislike form ===============================================================
.dislike-form {
  color: rgba(91, 91, 91, 1);
  font: 14px/19px sans-serif;

  &__header {
    margin-bottom: 25px;
  }

  &__title {
    margin-bottom: 2px;
  }

  &__optional-mark {
    color: rgba(0, 0, 0, 0.5);
    font-weight: 500;
  }

  &__subtitle {
  }

  &__checkboxes-row {
    gap: 10px;
    margin-bottom: 25px;
    display: flex;
    flex-wrap: wrap;
  }

  &__checkbox {
  }

  &__textarea-title {
    margin-bottom: 10px;
  }

  &__textarea {
    height: 70px;
    min-height: 70px;
  }
}
</style>
